import Repository from "@/repositories/Repository";

// Verb 	    URI 	                Action 	  Route Name
// GET 	      /photos 	            index 	  photos.index
// GET 	      /photos/create 	      create 	  photos.create
// POST 	    /photos 	            store 	  photos.store
// GET 	      /photos/{photo} 	    show 	    photos.show
// GET 	      /photos/{photo}/edit 	edit 	    photos.edit
// PUT/PATCH 	/photos/{photo} 	    update 	  photos.update
// DELETE 	  /photos/{photo} 	    destroy 	photos.destroy

const resource = "/registries";
export default {
  create() {
    // get the create form
    return Repository.get(`${resource}/create`);
  },
  edit(id) {
    // get the edit form
    return Repository.get(`${resource}/${id}/edit`);
  },
  validate(field, payload) {
    return Repository.post(`${resource}/validation/${field}`, payload);
  },
  parsecf(field, payload) {
    return Repository.post(`${resource}/parsecf/${field}`, payload);
  },
  national_insurance(field, payload) {
    return Repository.post(`${resource}/national_insurance/${field}`, payload);
  },
  index(queryString, config = {}) {
    // get the list
    return queryString
        ? Repository.get(`${resource}?${queryString}`, config)
        : Repository.get(`${resource}`, config);
  },
  show(id, relationString) {
    return relationString
      ? Repository.get(`${resource}/${id}/${relationString}`)
      : Repository.get(`${resource}/${id}`);
  },
  store(payload) {
    // save the item
    return Repository.post(`${resource}`, payload);
  },
  communications(id, queryString) {
    // messaggi inviati al cliente da LisaComunica (procedure e analisi)
    return queryString
      ? Repository.get(`${resource}/${id}/communications?${queryString}`)
      : Repository.get(`${resource}/${id}/communications`);
  },
  communication(id, logId) {
    // un messaggio inviato al cliente, con il contenuto spedito
    return Repository.get(`${resource}/${id}/communications/${logId}`);
  },
  unify(payload) {
    // unify duplicated registries into a single one
    // payload = { targetRegistryId, sourceRegistryIds: [...] }
    return Repository.post(`${resource}/unify`, payload);
  },
  update(id, payload) {
    // update the item
    return Repository.put(`${resource}/${id}`, payload);
  },
  update_chan(id, chan_id) {
    // update the item
    return Repository.put(`${resource}/${id}/chan-update/${chan_id}`);
  },
  destroy(id) {
    // delete the item
    return Repository.delete(`${resource}/${id}`);
  },
  pivot_store(id, relation, payload) {
    // store the related data, where payload = {
    //   "registry": {
    //     "1": {
    //       "primary": "Y",
    //       "is_coordinator": "Y",
    //       "communication_type": 2
    //     },
    //   }
    // }
    // (se mando in POST 1 solo record, insert or update solo su quello)
    return Repository.post(`${resource}/${id}/pivot/${relation}`, payload);
  },
  pivot_destroy(id, relation, payload) {
    // delete the related data ids , where payload = { `${relation}`: [1,2,...,N] }
    // eg: if relation is registry, payload = { registry: [1,2,...,N] }
    return Repository.delete(`${resource}/${id}/pivot/${relation}`, {
      data: payload,
    });
  },
  pivot_update(id, relation, payload) {
    // update the related data
    // (se mando in PUT 1 solo record, insert or update MA toglie tutti gli altri)
    return Repository.put(`${resource}/${id}/pivot/${relation}`, payload);
  },
  // Report EXPOMON (CSV)
  report(payload) {
    // save the item
    return Repository.post(`${resource}/export`, payload);
  },
};
